import styled from 'styled-components';
import { px2rem } from 'decisiv-ui-utils';

const OptionButton = styled.a`
  span:not(:first-of-type) {
    margin-left: ${px2rem(10)};
  }
`;

export default OptionButton;



// WEBPACK FOOTER //
// ./components/Search/SearchBar/SearchOption/OptionButton.js